const defaultClickEvent = {
	event: 'widgetUserEvent',
	element: 'More details button',
	elementCTA: 'Details',
	action: 'clicked',
	result: 'Revealed detail information popup',
	widgetName: 'ws-detailed-incentives',
	widgetId: 'detailed-incentives1',
	widgetState: 'default',
	fieldValue: undefined,
	formId: undefined,
	formEventId: undefined,
	value: undefined
};

function trackGoogleAnalyticsEvent(eventData) {
	const trackingObject = window.jQuery(document) || {};

	if (Object.keys(trackingObject).length > 0) {
		trackingObject.trigger('trackEvent', {
			...defaultClickEvent,
			...eventData
		});
	}
}

export function viewSpecialsDetailsEvent(widgetName, widgetId, elementCTA) {
	const eventData = {
		widgetName,
		widgetId,
		elementCTA,
		element: 'Specials details link',
		result: 'Opened dialog'
	};
	trackGoogleAnalyticsEvent(eventData);
}

export function closeSpecialsDetailsEvent(widgetName, widgetId) {
	const eventData = {
		element: 'Close button',
		elementCTA: undefined,
		action: 'clicked',
		result: 'Closed dialog',
		widgetState: 'Special dialog',
		widgetName,
		widgetId
	};
	trackGoogleAnalyticsEvent(eventData);
}

export function toggleSpecialsEvent(
	widgetName,
	widgetId,
	elementCTA,
	toggleState
) {
	const eventData = {
		widgetName,
		widgetId,
		elementCTA,
		element: 'Available specials accordion',
		result: `Available specials ${toggleState ? 'expanded' : 'collapsed'}`
	};
	trackGoogleAnalyticsEvent(eventData);
}



// WEBPACK FOOTER //
// ./src/utils/analytics.js